export default __webpack_public_path__ + "static/5-7b7a1449035c33f15cc015308bbd6838.webp";